import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  type = 'website'
}) => {
  const siteUrl = 'https://coercivecontrolpatterns.com';
  const defaultTitle = 'Coercive Control Pattern Analysis';
  const defaultDescription = 'AI-powered document analysis that identifies coercive control patterns in communications. Professional reports for legal and safety documentation.';
  
  const fullTitle = title ? `${title} | Coercive Control Patterns` : defaultTitle;
  const fullDescription = description || defaultDescription;
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonical} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={fullCanonical} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
    </Helmet>
  );
};

export default SEO;
